import moment from 'moment';

const getGenerateScheduleRequest = (data) => {
  const customDoubleDates = [];
  const startDoubleDates = new Date(data?.customDoubleDates[0]).getDate();
  const endDoubleDates = new Date(data?.customDoubleDates[1]).getDate();

  for (let i = startDoubleDates; i <= endDoubleDates; i++) {
    const date = new Date(data?.customDoubleDates[0]).setDate(i);
    customDoubleDates.push(moment(date).format('YYYY-MM-DD'));
  }

  const payload = {
    rulesetId: data?.rulesetId?.id,
    yearMonth: moment(data?.yearMonth).format('YYYY-MM'),
    brandName: data?.brand?.value,
    totalDaysOffPerHost: parseInt(data?.totalDaysOffPerHost),
    customDoubleDates,
    hostLeaves: [],
    generationMethod: 'code-new',
  };

  if (data?.peakDays.length) {
    const peakDays = [];
    for (const peakDay of data.peakDays) {
      const startPeakDates = new Date(peakDay[0]).getDate();
      const endPeakDates = new Date(peakDay[1]).getDate();

      for (let i = startPeakDates; i <= endPeakDates; i++) {
        const date = new Date(peakDay[0]).setDate(i);
        peakDays.push(moment(date).format('YYYY-MM-DD'));
      }
    }
    payload.peakDays = peakDays;
  }
  if (data?.hostLeaves.length) {
    const hostLeaves = data.hostLeaves.map((leave) => {
      return {
        hostId: leave.hostId?.id,
        leaves: leave.leaves.map((date) => moment(date).format('YYYY-MM-DD')),
      };
    });
    payload.hostLeaves = hostLeaves;
  }

  return payload;
};

export default getGenerateScheduleRequest;
